
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeTaxGrid extends Serenity.EntityGrid<ECommExchangeTaxRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchangeTax'; }
        protected getIdProperty() { return ECommExchangeTaxRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeTaxRow.localTextPrefix; }
        protected getService() { return ECommExchangeTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}